export const presetParams = preset => {
  if (!preset) {
    return ['', '']
  }

  const [platform, identity] = preset.split(':')

  return [platform, identity]
}
